import React, {useEffect, useState} from 'react';
import './TypePrintSadanShop.scss'
import numericFunction from "../../../utils/NumericFunction";
import DynaTable from "../../MyTable/DynaTable";

const ReviewAccountsPrint = (props) => {

  const componentData = props.data.data
  const [makePage, setMakePage] = useState([])
  const [myColumn, setMyColumn] = useState([])
  const format = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  useEffect(() => {

    let makeColumn = []
      componentData.column.forEach((c) => {
        makeColumn.push({...c, headerFilter: true})
      })
    setMyColumn(makeColumn)

    if (componentData.data.length > 23) {
      let i = 0;
      let mainData = []
      while (i < componentData.data.length) {

        let temp = []
        for (let j = 0; j < 23; j++) {
          temp.push(componentData.data[i])
          i = i + 1;
          if (i === componentData.data.length) {
            break;
          }
        }
        mainData.push(temp)
      }
      setMakePage(mainData)
    } else {
      let temp = []
      temp.push(componentData.data)
      setMakePage(temp)
    }
  }, [])

  return (
    <div className="main-print-factor">

      <div className="header-side">
        <h4>{props.data.title}</h4>
      </div>

      {makePage.length > 0 && makePage.map((v, index) =>
        <>
          <div className="box-top-side-review-accounts">

            <div className="shop-name">
              <div className="name-side">
                <h3>{componentData?.shopName}</h3>
              </div>
            </div>

            <div className="list-detail">
              <div className="inline-text">
                <p>از تاریخ :</p>
                <p>{numericFunction.e2p(componentData.startDate)}</p>
              </div>

              <div className="inline-text">
                <p>از سند :</p>
                <p>{numericFunction.e2p(componentData.firstId)}</p>
              </div>

              <div className="inline-text">
                <p>تـاریـخ :</p>
                <p>{new Date().toLocaleDateString("fa-ir", format)}</p>
              </div>

              <div className="inline-text">
                <p>تا تاریخ :</p>
                <p>{numericFunction.e2p(componentData.endDate)}</p>
              </div>

              <div className="inline-text">
                <p>تا سند :</p>
                <p>{numericFunction.e2p(componentData.lastId)}</p>
              </div>

              <div className="inline-text" style={{columnGap: '4px'}}>
                <p>شماره صفحه :</p>
                <p>{numericFunction.e2p(index + 1)}</p>
                <p>از</p>
                <p>{numericFunction.e2p(makePage.length)}</p>
              </div>
            </div>
          </div>

          <div className="box-table-side">

            <div className="main-table-print">
              <DynaTable
                column={myColumn}
                data={v}
                className={"DynaTable-print solid-table-print"}
                onRowClick={""}
                mainWidth={"100%"}
                priceFields={componentData.priceFields}
                showFooter={true}
                oneColumnStyle={{field: "name_3", style: {width: '220px'}}}
              />
            </div>
          </div>

          {makePage[makePage.length - 1] !== v && <div style={{pageBreakBefore: "always"}}></div>}
        </>
      )}

    </div>
  );
};

export default ReviewAccountsPrint;